export const letterS = {
  nouns: [
    {"juice": ["Saft", "Säfte", "der", "die", "m"]},
    {"salad": ["Salat", "Salate", "der", "die", "m"]},
    {"salt": ["Salz", "Salze", "das", "die", "n"]},
    {"sentence": ["Satz", "Sätze", "der", "die", "m"]},
    {"commuter train": ["S-Bahn", "S-Bahnen", "die", "die", "f"]},
    {"counter": ["Schalter", "Schalter", "der", "die", "m"]},
    {"sign": ["Schild", "Schilder", "das", "die", "n"]},
    {"ham": ["Schinken", "Schinken", "der", "die", "m"]},
    {"end": ["Schluss", "Schlüsse", "der", "die", "m"]},
    {"key": ["Schlüssel", "Schlüssel", "der", "die", "m"]},
    {"cupboard": ["Schrank", "Schränke", "der", "die", "m"]},
    {"shoe": ["Schuh", "Schuhe", "der", "die", "m"]},
    {"school": ["Schule", "Schulen", "die", "die", "f"]},
    {"student": ["Schüler", "Schüler", "der", "die", "m"]},
    {"sister": ["Schwester", "Schwestern", "die", "die", "f"]},
    {"swimming pool": ["Schwimmbad", "Schwimmbäder", "das", "die", "n"]},
    {"lake": ["See", "Seen", "der", "die", "m"]},
    {"sight": ["Sehenswürdigkeit", "Sehenswürdigkeiten", "die", "die", "f"]},
    {"sofa": ["Sofa", "Sofas", "das", "die", "n"]},
    {"son": ["Sohn", "Söhne", "der", "die", "m"]},
    {"sun": ["Sonne", "Sonnen", "die", "die", "f"]},
    {"menu": ["Speisekarte", "Speisekarten", "die", "die", "f"]},
    {"sport": ["Sport", "Sportarten", "der", "die", "m"]},
    {"language": ["Sprache", "Sprachen", "die", "die", "f"]},
    {"city": ["Stadt", "Städte", "die", "die", "f"]},
    {"place": ["Stelle", "Stellen", "die", "die", "f"]},
    {"floor": ["Stock", "Stockwerke", "der", "die", "m"]},
    {"street": ["Straße", "Straßen", "die", "die", "f"]},
    {"tram": ["Straßenbahn", "Straßenbahnen", "die", "die", "f"]},
    {"studies": ["Studium", "Studien", "das", "die", "n"]},
    {"student": ["Student", "Studenten", "der", "die", "m"]},    
    {"hour": ["Stunde", "Stunden", "die", "die", "f"]},
    {"end": ["Schluss", "Schlüsse", "der", "die", "m"]},
    {"conclusion": ["Schluss", "Schlüsse", "der", "die", "m"]}
  ],
  verbs: [
    {"to say": ["sagen", "sage", "sagst", "sagt", "sagt", "sagt", "sagen", "sagt", "sagen", "sagen"]},
    {"to seem": ["scheinen", "scheine", "scheinst", "scheint", "scheint", "scheint", "scheinen", "scheint", "scheinen", "scheinen"]},
    {"to send": ["schicken", "schicke", "schickst", "schickt", "schickt", "schickt", "schicken", "schickt", "schicken", "schicken"]},
    {"to sleep": ["schlafen", "schlafe", "schläfst", "schläft", "schläft", "schläft", "schlafen", "schlafen", "schlafen", "schlafen"]},
    {"to close": ["schließen", "schließe", "schließt", "schließt", "schließt", "schließt", "schließen", "schließt", "schließen", "schließen"]},
    {"to taste": ["schmecken", "schmecke", "schmeckst", "schmeckt", "schmeckt", "schmeckt", "schmecken", "schmeckt", "schmecken", "schmecken"]},
    {"to write": ["schreiben", "schreibe", "schreibst", "schreibt", "schreibt", "schreibt", "schreiben", "schreibt", "schreiben", "schreiben"]},
    {"to swim": ["schwimmen", "schwimme", "schwimmst", "schwimmt", "schwimmt", "schwimmt", "schwimmen", "schwimmt", "schwimmen", "schwimmen"]},
    {"to see": ["sehen", "sehe", "siehst", "sieht", "sieht", "sieht", "sehen", "seht", "sehen", "sehen"]},
    {"to sit": ["sitzen", "sitze", "sitzt", "sitzt", "sitzt", "sitzt", "sitzen", "sitzt", "sitzen", "sitzen"]},
    {"to should": ["sollen", "soll", "sollst", "soll", "soll", "soll", "sollen", "sollt", "sollen", "sollen"]},
    {"to play": ["spielen", "spiele", "spielst", "spielt", "spielt", "spielt", "spielen", "spielt", "spielen", "spielen"]},
    {"to speak": ["sprechen", "spreche", "sprichst", "spricht", "spricht", "spricht", "sprechen", "sprecht", "sprechen", "sprechen"]},
    {"to stand": ["stehen", "stehe", "stehst", "steht", "steht", "steht", "stehen", "steht", "stehen", "stehen"]},
    {"to put, to place": ["stellen", "stelle", "stellst", "stellt", "stellt", "stellt", "stellen", "stellt", "stellen", "stellen"]},
    {"to study": ["studieren", "studiere", "studierst", "studiert", "studiert", "studiert", "studieren", "studiert", "studieren", "studieren"]},
    {"to search": ["suchen", "suche", "suchst", "sucht", "sucht", "sucht", "suchen", "sucht", "suchen", "suchen"]},
    {"to collect": ["sammeln", "sammle", "sammelst", "sammelt", "sammelt", "sammelt", "sammeln", "sammelt", "sammeln", "sammeln"]},
    {"to cut": ["schneiden", "schneide", "schneidest", "schneidet", "schneidet", "schneidet", "schneiden", "schneidet", "schneiden", "schneiden"]},
    {"to set": ["setzen", "setze", "setzt", "setzt", "setzt", "setzt", "setzen", "setzt", "setzen", "setzen"]},
    {"to climb": ["steigen", "steige", "steigst", "steigt", "steigt", "steigt", "steigen", "steigt", "steigen", "steigen"]},
    {"to die": ["sterben", "sterbe", "stirbst", "stirbt", "stirbt", "stirbt", "sterben", "sterbt", "sterben", "sterben"]}

  ],
  examples: {
    nominative: [
      {
        german: '___ Saft ist süß.',
        english: 'The juice is sweet.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Salat ist frisch.',
        english: 'The salad is fresh.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Salz ist weiß.',
        english: 'The salt is white.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Satz ist kurz.',
        english: 'The sentence is short.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ S-Bahn kommt.',
        english: 'The S-Bahn is coming.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Schluß ist da.',
        english: 'The end is here.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Schüler lernt.',
        english: 'The student learns.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Schwester hilft.',
        english: 'The sister helps.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ See ist tief.',
        english: 'The lake is deep.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Sonne scheint.',
        english: 'The sun is shining.',
        answer: 'Die',
        case: 'nominative'
      }      
    ],
    accusative: [
      {
        german: 'Ich trinke ___ Saft.',
        english: 'I drink the juice.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie isst ___ Salat.',
        english: 'She eats the salad.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Er braucht ___ Salz.',
        english: 'He needs the salt.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Wir lesen ___ Satz.',
        english: 'We read the sentence.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Du nimmst ___ S-Bahn.',
        english: 'You take the S-Bahn.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Ich schreibe ___ Satz.',
        english: 'I write the sentence.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie besucht ___ Schüler.',
        english: 'She visits the student.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Er sieht ___ Schwester.',
        english: 'He sees the sister.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir finden ___ Schlüssel.',
        english: 'We find the key.',
        answer: 'den',
        case: 'accusative'
      }
    ],
    dative: [
      {
        german: 'Ich helfe ___ Schüler.',
        english: 'I help the student.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie spricht mit ___ Schwester.',
        english: 'She speaks with the sister.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er geht zu ___ S-Bahn.',
        english: 'He goes to the S-Bahn.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Wir sitzen in ___ Schule.',
        english: 'We sit in the school.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du arbeitest für ___ Schüler.',
        english: 'You work for the student.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Ich komme aus ___ Stadt.',
        english: 'I come from the city.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Sie dankt ___ Schwestern.',
        english: 'She thanks the sisters.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Er lebt am ___ See.',
        english: 'He lives at the lake.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir warten auf ___ Sonne.',
        english: 'We wait for the sun.',
        answer: 'die',
        case: 'dative'
      }
    ],
    translations: [
      {
        english: 'The juice is sweet.',
        german: 'Der Saft ist süß.',
        type: 'translation',
        case: 'nominative'
      },
      {
        english: 'The student learns quickly.',
        german: ['Der Schüler lernt schnell.', 'Der Student lernt schnell.'],
        type: 'translation',
        case: 'nominative'
      },
      {
        english: 'She speaks with the student.',
        german: ['Sie spricht mit dem Schüler.', 'Sie spricht mit dem Studenten.'],
        type: 'translation',
        case: 'dative'
      },
      {
        english: 'The student searches for the book.',
        german: ['Der Schüler sucht das Buch.', 'Der Student sucht das Buch.'],
        type: 'translation',
        case: 'accusative'
      },      
      {
        english: 'She eats the salad.',
        german: 'Sie isst den Salat.',
        type: 'translation',
        case: 'accusative'
      },
      {
        english: 'I help the student.',
        german: 'Ich helfe dem Schüler.',
        type: 'translation',
        case: 'dative'
      },
      {
        english: 'The student learns quickly.',
        german: 'Der Schüler lernt schnell.',
        type: 'translation',
        case: 'nominative'
      },
      {
        english: 'We write the sentence.',
        german: 'Wir schreiben den Satz.',
        type: 'translation',
        case: 'accusative'
      },
      {
        english: 'The school is big.',
        german: 'Die Schule ist groß.',
        type: 'translation',
        case: 'nominative'
      },
      {
        english: 'He sees the sister.',
        german: 'Er sieht die Schwester.',
        type: 'translation',
        case: 'accusative'
      },
      {
        english: 'She speaks with the student.',
        german: 'Sie spricht mit dem Schüler.',
        type: 'translation',
        case: 'dative'
      },
      {
        english: 'The sun shines brightly.',
        german: 'Die Sonne scheint hell.',
        type: 'translation',
        case: 'nominative'
      },
      {
        english: 'We play football.',
        german: 'Wir spielen Fußball.',
        type: 'translation',
        case: 'accusative'
      },
      {
        english: 'You stand at the door.',
        german: 'Du stehst an der Tür.',
        type: 'translation',
        case: 'dative'
      },
      {
        english: 'The key is lost.',
        german: 'Der Schlüssel ist verloren.',
        type: 'translation',
        case: 'nominative'
      },
      {
        english: 'I study German.',
        german: 'Ich studiere Deutsch.',
        type: 'translation',
        case: 'accusative'
      },
      {
        english: 'The soup tastes good.',
        german: 'Die Suppe schmeckt gut.',
        type: 'translation',
        case: 'nominative'
      },
      {
        english: 'They swim in the lake.',
        german: 'Sie schwimmen im See.',
        type: 'translation',
        case: 'dative'
      },
      {
        english: 'She closes the door.',
        german: 'Sie schließt die Tür.',
        type: 'translation',
        case: 'accusative'
      },
      {
        english: 'We sleep well.',
        german: 'Wir schlafen gut.',
        type: 'translation',
        case: 'nominative'
      },
      {
        english: 'The student searches for the book.',
        german: 'Der Schüler sucht das Buch.',
        type: 'translation',
        case: 'accusative'
      }
    ],
    conjugations: [
      {
        question: 'How do you conjugate "to say" for "I"?',
        answer: 'sage',
        verb: 'sagen',
        verbEnglish: 'to say',
        subject: 'ich',
        conjugation: 'sage'
      },
      {
        question: 'How do you conjugate "to write" for "you" (informal)?',
        answer: 'schreibst',
        verb: 'schreiben',
        verbEnglish: 'to write',
        subject: 'du',
        conjugation: 'schreibst'
      },
      {
        question: 'How do you conjugate "to sleep" for "he"?',
        answer: 'schläft',
        verb: 'schlafen',
        verbEnglish: 'to sleep',
        subject: 'er',
        conjugation: 'schläft'
      },
      {
        question: 'What is the simple past of "to see" for "she"?',
        answer: 'sah',
        verb: 'sehen',
        verbEnglish: 'to see',
        subject: 'sie',
        conjugation: 'sah'
      },
      {
        question: 'What is the simple past of "to play" for "we"?',
        answer: 'spielten',
        verb: 'spielen',
        verbEnglish: 'to play',
        subject: 'wir',
        conjugation: 'spielten'
      },
      {
        question: 'What is the simple past of "to speak" for "they"?',
        answer: 'sprachen',
        verb: 'sprechen',
        verbEnglish: 'to speak',
        subject: 'sie',
        conjugation: 'sprachen'
      },
      {
        question: 'How do you conjugate "to stand" for "I"?',
        answer: 'stehe',
        verb: 'stehen',
        verbEnglish: 'to stand',
        subject: 'ich',
        conjugation: 'stehe'
      },
      {
        question: 'What is the simple past of "to study" for "she"?',
        answer: 'studierte',
        verb: 'studieren',
        verbEnglish: 'to study',
        subject: 'sie',
        conjugation: 'studierte'
      },
      {
        question: 'How do you conjugate "to search" for "we"?',
        answer: 'suchen',
        verb: 'suchen',
        verbEnglish: 'to search',
        subject: 'wir',
        conjugation: 'suchen'
      },
      {
        question: 'What is the simple past of "to sleep" for "they"?',
        answer: 'schliefen',
        verb: 'schlafen',
        verbEnglish: 'to sleep',
        subject: 'sie',
        conjugation: 'schliefen'
      },
      {
        question: 'How do you conjugate "to close" for "I"?',
        answer: 'schließe',
        verb: 'schließen',
        verbEnglish: 'to close',
        subject: 'ich',
        conjugation: 'schließe'
      },
      {
        question: 'What is the simple past of "to write" for "I"?',
        answer: 'schrieb',
        verb: 'schreiben',
        verbEnglish: 'to write',
        subject: 'ich',
        conjugation: 'schrieb'
      },
      {
        question: 'How do you conjugate "to swim" for "she"?',
        answer: 'schwimmt',
        verb: 'schwimmen',
        verbEnglish: 'to swim',
        subject: 'sie',
        conjugation: 'schwimmt'
      },
      {
        question: 'What is the simple past of "to sit" for "we"?',
        answer: 'saßen',
        verb: 'sitzen',
        verbEnglish: 'to sit',
        subject: 'wir',
        conjugation: 'saßen'
      },
      {
        question: 'How do you conjugate "to seem" for "he"?',
        answer: 'scheint',
        verb: 'scheinen',
        verbEnglish: 'to seem',
        subject: 'er',
        conjugation: 'scheint'
      }
    ]
  }
}
